import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../store/hooks';
import { getProjectImage } from '../Presentation/projectActions';

export const useProjectImage = (idOrUrl?: string) => {
  const [url, setUrl] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!idOrUrl) {
      setUrl(undefined);
      return;
    }

    // URL 형태인지 확인 (http, https, data:, blob:)
    if (idOrUrl.startsWith('http') || idOrUrl.startsWith('data:') || idOrUrl.startsWith('blob:')) {
      setUrl(idOrUrl);
      return;
    }

    // ID 형태라고 가정하고 API 호출
    const fetchImage = async () => {
      setLoading(true);
      try {
        const result = await dispatch(getProjectImage({ image_id: idOrUrl })).unwrap();
        if (result.image_url) {
          setUrl(result.image_url);
        }
      } catch (error) {
        console.error('Failed to fetch image:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchImage();
  }, [idOrUrl, dispatch]);

  return { url, loading };
};
